import React, { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import PrerenderManager from "../../Code/PrerenderManager"

/**
 * JsonLd component for injecting Schema.org structured data into <head>
 * via react-helmet-async.
 */
export default function JsonLd({ schema }) {
  if (!schema) return null

  const content = typeof schema === "string" ? schema : JSON.stringify(schema)
  // This component uses React-Helmet, so require the helmet operation
  useEffect(() => {
    PrerenderManager.requireOperation('helmet');
  }, []);

  const handleHelmetChange = () => {
    setTimeout(() => PrerenderManager.markReady('helmet'), 0);
  }

  return (
    <Helmet onChangeClientState={handleHelmetChange} defer={false}>
      <script type="application/ld+json">
        {content}
      </script>
    </Helmet>
  )
}
